import * as React from "react";
import { PageBase, SmallFormGenerator } from "../../components";
import { FieldGroup, showSuccess, FGTextInput, FGEmpty, FieldSet } from "nsitools-react";
import { UsersApi, EPlatform } from "../../api";
import * as Yup from "yup";
import { ETLCodes } from "../../locales";
import { useTl, useApiService } from "../../hooks";
import { useHistory, useParams } from "react-router";
import { ELoginRoutes } from "../../LoginRouter";
export interface IPasswordPageProps {}

export const PasswordPage: React.FunctionComponent<IPasswordPageProps> = (props) => {
  const { userId } = useParams<{ userId }>();
  const api = useApiService(UsersApi);
  const history = useHistory();
  const { t } = useTl();
  const save = React.useCallback(
    async (values: any) => {
      const res = await api.changePassword(values.password);
      if (res !== null) {
        showSuccess(t(ETLCodes.PasswordChanged));
        history.push(ELoginRoutes.login);
      }
      return res;
    },
    [api, history, t]
  );
  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      passwordValidation: Yup.string()
        .required(t(ETLCodes.Required))
        .test("is-equal", t(ETLCodes.PasswordMustMatch), async function (value) {
          return value === this.parent.password;
        }),
    });
  }, [t]);
  return (
    <PageBase>
      <FieldSet collapsable={false} title={t(ETLCodes.PasswordChangeTitle)}>
        <SmallFormGenerator
          initialValues={{ password: "", passwordValidation: "" }}
          onSubmit={save}
          editMode={true}
          validationSchema={FormSchema}
          loading={false}
          saving={false}
          minLabelWidth={190}
          enableDirtyCheck={false}
        >
          <FieldGroup columns={2}>
            <FGTextInput name="password" label={t(ETLCodes.General_Password)} type="password" />
            <FGEmpty />
            <FGTextInput name="passwordValidation" label={t(ETLCodes.PasswordValidation)} type="password" />
            <FGEmpty />
          </FieldGroup>
        </SmallFormGenerator>
      </FieldSet>
    </PageBase>
  );
};
